import styled from "styled-components";

import { colors } from "const/colors";
import { colorCycle } from "const/content";

const Wrap = styled.div`
	width: 100%;
	min-width: 0;
`;

const Label = styled.div`
	margin-bottom: 14px;
	font-size: 15px;
	font-weight: 800;
	letter-spacing: 0.04em;
	text-transform: uppercase;
	color: ${colors.gray};
	font-family:
		Helvetica Neue,
		Helvetica,
		Arial,
		sans-serif;
`;

const Row = styled.div`
	display: flex;
	flex-wrap: wrap;
	gap: 10px;
	width: 100%;
	min-width: 0;
	box-sizing: border-box;
`;

const Chip = styled.span`
	background: #fff;
	border: 1px solid ${({ color }) => color};
	border-radius: 999px;
	padding: 10px 16px;
	font-size: 16px;
	font-weight: 700;
	color: ${({ color }) => color};
	max-width: 100%;
	line-height: 1.35;
`;

export default function PromptChips({ prompts }) {
	return (
		<Wrap>
			<Label>Try asking</Label>
			<Row>
				{prompts.map((prompt, index) => (
					<Chip key={prompt} color={colorCycle[index % colorCycle.length]}>
						{prompt}
					</Chip>
				))}
			</Row>
		</Wrap>
	);
}
